module.exports = __webpack_public_path__ + "img/revisao5.5f7e2ead.jpg";